import React from 'react';
import { Container } from '@hover/blueprint';
import ReadyToSeeTabletAndDesktop from './ReadyToSeeTabletAndDesktop';
import ReadyToSeeMobile from './ReadyToSeeMobile';

const HomePageReadyToSee: React.FC = () => (
  <Container
    maxW="1248px"
    mb={1000}
    px={{ base: 500, tablet: '56px', desktop: 500 }}
    mt={{ tablet: 1000, desktop: 1100 }}
  >
    <ReadyToSeeTabletAndDesktop />
    <ReadyToSeeMobile />
  </Container>
);

export default HomePageReadyToSee;
